export const sharedColors = {
  border: '1px solid #ffffff',
  linkBorder: '1px solid #D9D9D9',
  darkGreyText: '#14171a',
  medGreyText: '#657786',
  momentBorder: '1px solid #f0f3f4',
}
